<template>
    <div class="dialog-advanced-filter" v-if="show">
        <div class="dialog-advanced-filter__header">
            <span class="dialog-advanced-filter__title">
                {{ translate('btn_advanced_filters') }}
            </span>
            <div class="dialog-advanced-filter__action">
                <el-link v-if="hasFilters" @click="clearFilters">
                    {{ translate('clear_filters') }}
                </el-link>
                <el-link @click="$emit('applyFilter')">
                    {{ translate('apply_filters') }}
                </el-link>
            </div>
        </div>
        <div class="dialog-advanced-filter__content">
            <el-form>
                <el-collapse v-model="collapseSelected">
                    <el-collapse-item
                        :title="translate('initial_date_label')"
                        name="1"
                    >
                        <el-date-picker
                            v-model='filter.initialDate_initial'
                            class='mr-2'
                            type='date'
                            :placeholder="translate('rangeInicialDate')"
                            format='dd/MM/yyyy'
                            value-format="yyyy-MM-dd"
                            @change='handleFilterChange'
                        />
                    </el-collapse-item>
                    <el-collapse-item
                        :title="translate('end_date_label')"
                        name="2"
                    >
                        <el-date-picker
                            v-model='filter.endDate_initial'
                            class='mr-2'
                            type='date'
                            :placeholder="translate('rangeInicialDate')"
                            format='dd/MM/yyyy'
                            value-format="yyyy-MM-dd"
                            @change='handleFilterChange'
                        />
                    </el-collapse-item>
                    <el-collapse-item
                        :title="translate('status')"
                        name="3"
                    >
                        <el-checkbox-group
                            v-model='filter.fileProcessingStatus'
                            class=""
                            @change='handleFilterChange'
                            :max="1"
                        >
                            <el-checkbox label="SOLICITADO" class="checkbox-area_view-invoice-filter">
                                {{ translate('requested') }}
                            </el-checkbox>
                            <el-checkbox label="EM_PROCESSAMENTO" class="checkbox-area_view-invoice-filter">
                                {{ translate('in_processing') }}
                            </el-checkbox>
                            <el-checkbox label="PROCESSADO" class="checkbox-area_view-invoice-filter">
                                {{ translate('processed') }}
                            </el-checkbox>
                            <el-checkbox label="PROCESSADO_COM_ERRO" class="checkbox-area_view-invoice-filter">
                                {{ translate('processed_with_error') }}
                            </el-checkbox>
                            <el-checkbox label="ERRO" class="checkbox-area_view-invoice-filter">
                                {{ translate('error') }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-collapse-item>
                </el-collapse>
            </el-form>
        </div>
    </div>
</template>

<script>

export default {
    name: 'dialog-advanced-filters',
    data() {
        return {
            collapseSelected: [1],
            filter: {
                fileType: 'ARMAZEM',
                fileProcessingStatus: [],
                initialDate_initial: null,
                endDate_initial: null
            }
        };
    },
    props: {
        show: {
            type: Boolean,
            required: true,
            default: () => false
        }
    },
    mounted() {
        this.$emit('handleFilter', this.filter, true);
    },
    computed: {
        hasFilters() {
            return (
                true
            );
        }
    },
    methods: {
        translate(key, params = {}) {
            const base = 'warehouse.warehouse_registration_page.main_filter';
            return this.$t(`${base}.${key}`, params);
        },
        handleFilterChange() {
            this.$emit('handleFilter', this.filter, false);
        },
        clearFilters() {
            this.filter.fileProcessingStatus = [];
            this.filter.initialDate_initial = null;
            this.filter.endDate_initial = null;
            this.$emit('clear');
        }
    }
};
</script>

<style scoped lang="scss">
.dialog-advanced-filter {
    width: 100%;

    .dialog-advanced-filter__header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .dialog-advanced-filter__title {
            font-weight: 500;
            font-size: 16px;
            color: #00413c;
        }

        .dialog-advanced-filter__action {
            display: flex;
            gap: 16px;

            .el-link:first-child {
                color: #e35e58;
                font-size: 14px;
                font-weight: 400;
            }

            .el-link:last-child {
                color: #036be4;
                font-size: 14px;
                font-weight: 400;
            }
        }
    }

    .dialog-advanced-filter__content {
        .dialog-advanced-filter__content__status {
            display: grid;
            grid-template-columns: 1fr 1fr auto;
            gap: 16px;
        }

        .dialog-advanced-filter__content__cultivation {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
            gap: 32px;
        }
    }
}

.checkbox-area_view-invoice-filter {
    padding: 0 12px 0 0;
}
</style>
